export default function Profile() {
  return (
    <div className="fade-in">
      <h2>Company Profile</h2>

      <div className="text-content">
        <p>
          Focussed Solutions has grown into a
          trusted partner in the RF & Microwave industry.
        </p>

        <p>
          We specialize in supplying high-reliability electronic components to
          Defence, Space, Telecom, and Industrial sectors. Our partners include
          leading manufacturers from the USA, Europe, and Asia.
        </p>

        <ul>
          <li>Headquarters: New Delhi, India</li>
          <li>Specialization: RF & Microwave Components</li>
        </ul>
      </div>
    </div>
  );
}